import React, { useState, useEffect } from 'react';
import {
    Box, TextField, Button, Typography, Stack
} from '@mui/material';
import axios from 'axios';

const BuildingDetailsFloorsAddFloor = ({ buildingId, floor, onSuccess, onError, onClose }) => {
    const [formData, setFormData] = useState({
        floor_level: '',
        area: '',
        u_value: '',
        u_value_uninsulated: ''
    });

    useEffect(() => {
        if (floor) {
            setFormData({
                floor_level: floor.floor_level,
                area: floor.area,
                u_value: floor.u_value,
                u_value_uninsulated: floor.u_value_uninsulated
            });
        }
    }, [floor]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const payload = {
            ...formData,
            floor_level: parseInt(formData.floor_level),
            area: parseFloat(formData.area),
            u_value: parseFloat(formData.u_value),
            u_value_uninsulated: parseFloat(formData.u_value_uninsulated),
            building: parseInt(buildingId)
        };

        const request = floor
            ? axios.put(`/buildings/${buildingId}/floor/${floor.id}/`, payload)
            : axios.post(`/buildings/${buildingId}/floor/`, payload);

        request
            .then(() => {
                onSuccess();
                onClose();
            })
            .catch(() => {
                onError();
            });
    };

    return (
        <Box component="form" onSubmit={handleSubmit} sx={{ p: 2, width: 400 }}>
            <Typography variant="h6" gutterBottom mb={2}>
                {floor ? 'Edit Floor' : 'Add New Floor'}
            </Typography>
            <Stack spacing={2}>
                <TextField
                    name="floor_level"
                    label="Floor Level"
                    type="number"
                    inputProps={{ min: 0, step: 1 }}
                    required
                    fullWidth
                    value={formData.floor_level}
                    onChange={handleChange}
                />
                <TextField
                    name="area"
                    label="Area (m²)"
                    type="number"
                    inputProps={{ min: 0, step: 0.1 }}
                    required
                    fullWidth
                    value={formData.area}
                    onChange={handleChange}
                />
                <TextField
                    name="u_value"
                    label="U-Value (Insulated)"
                    type="number"
                    inputProps={{ min: 0, step: 0.1 }}
                    required
                    fullWidth
                    value={formData.u_value}
                    onChange={handleChange}
                />
                <TextField
                    name="u_value_uninsulated"
                    label="U-Value (Uninsulated)"
                    type="number"
                    inputProps={{ min: 0, step: 0.1 }}
                    required
                    fullWidth
                    value={formData.u_value_uninsulated}
                    onChange={handleChange}
                />
                <Stack direction="row" spacing={2} justifyContent="flex-end">
                    <Button onClick={onClose} variant="outlined" color="secondary">
                        Cancel
                    </Button>
                    <Button type="submit" variant="contained">
                        {floor ? 'Update Floor' : 'Add Floor'}
                    </Button>
                </Stack>
            </Stack>
        </Box>
    );
};


export default BuildingDetailsFloorsAddFloor;
